import { BowArrow, Crosshair } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { renderToStaticMarkup } from "react-dom/server";

import {
  BOARD_CURSOR_ATTACK_FILL,
  BOARD_CURSOR_WAIT_FILL,
} from "#/components/game/gameCanvas/boardCursors";
import { loadCachedImage } from "#/game/cachedImage";

export const ATTACK_RANGE_FLASH_ICON_SIZE = 16;

export type AttackRangeFlashIconStyle = "strike" | "coverage";

function flashIconDataUrl({
  Icon,
  discFill,
  iconFill,
}: {
  Icon: LucideIcon;
  discFill: string;
  iconFill: string;
}): string {
  return `data:image/svg+xml;utf8,${encodeURIComponent(
    renderToStaticMarkup(
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={ATTACK_RANGE_FLASH_ICON_SIZE}
        height={ATTACK_RANGE_FLASH_ICON_SIZE}
        viewBox={`0 0 ${ATTACK_RANGE_FLASH_ICON_SIZE} ${ATTACK_RANGE_FLASH_ICON_SIZE}`}
      >
        <circle
          cx={ATTACK_RANGE_FLASH_ICON_SIZE / 2}
          cy={ATTACK_RANGE_FLASH_ICON_SIZE / 2}
          r={ATTACK_RANGE_FLASH_ICON_SIZE / 2 - 1}
          fill={discFill}
          stroke="#ffffff"
          strokeWidth="1"
        />
        <g
          transform={`translate(${ATTACK_RANGE_FLASH_ICON_SIZE / 4} ${ATTACK_RANGE_FLASH_ICON_SIZE / 4})`}
        >
          <Icon
            size={ATTACK_RANGE_FLASH_ICON_SIZE / 2}
            fill={iconFill}
            stroke="#ffffff"
            strokeWidth={2.25}
          />
        </g>
      </svg>,
    ),
  )}`;
}

const FLASH_ICON_DATA_URL: Record<AttackRangeFlashIconStyle, string> = {
  strike: flashIconDataUrl({
    Icon: BowArrow,
    discFill: BOARD_CURSOR_ATTACK_FILL,
    iconFill: "none",
  }),
  coverage: flashIconDataUrl({
    Icon: Crosshair,
    discFill: BOARD_CURSOR_WAIT_FILL,
    iconFill: "none",
  }),
};

export function getAttackRangeFlashIconImage(
  style: AttackRangeFlashIconStyle = "strike",
): HTMLImageElement {
  return loadCachedImage(FLASH_ICON_DATA_URL[style]);
}
